import { __assign } from "tslib";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import PremiumFolderDisc from '@wix/da-ds/pkg/Icons/PremiumFolderDisc';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/24x24/EyeDisc2';
import CoreIconSmall from '@wix/da-ds/pkg/Icons/CoreIconSmall';
import Points from '@wix/da-ds/pkg/Icons/Points';
import useBiDataForDeviationLink from '../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import Button, { ProfileOwnerWatchButton } from '../../../../Button';
import { URLS, Url } from '@wix/da-url';
import s from './PremiumCover.scss';
export var PremiumCover = function (_a) {
    var premiumFolderData = _a.deviation.premiumFolderData, deviation = _a.deviation;
    var t = useTranslation().t;
    var linkBiData = useBiDataForDeviationLink(deviation);
    var _b = normalizePremiumFolderData(premiumFolderData), isPremiumLocked = _b.isPremiumLocked, isPaidFolder = _b.isPaidFolder, isWatchToAccess = _b.isWatchToAccess, isPrivilegedFolder = _b.isPrivilegedFolder, folderId = _b.folderId, folderUrl = _b.folderUrl, formattedDollarPrice = _b.formattedDollarPrice, pointPrice = _b.pointPrice, subproductId = _b.subproductId;
    if (!isPremiumLocked) {
        return null;
    }
    return (React.createElement("div", { className: s['paywall-wrapper'] },
        React.createElement("div", { className: s['paywall-cover'] },
            isPaidFolder && (React.createElement(React.Fragment, null,
                React.createElement(PremiumFolderDisc, { className: s['paywall-icon'], size: IconSize.BIG }),
                React.createElement("div", { className: s['paywall-title'] }, t('deviation.paywall.premiumFolders.title')),
                React.createElement("div", { className: s['cta-text'] },
                    React.createElement(Trans, { i18nKey: "deviation.paywall.premiumFolders.text" },
                        'To view, unlock its ',
                        React.createElement(BiLink, { className: s['folder-preview-button'], href: folderUrl }, "Premium Deviation"),
                        ' — and support the artist!')),
                React.createElement("div", null,
                    React.createElement(Button, { view: "b18", height: "medium", href: subproductId ? Url.checkoutLink(subproductId) : undefined, biData: __assign(__assign({}, linkBiData), { evid: BiEventType.GALLERY_PURCHASE, authorid: deviation.author.useridUuid, galleryid: folderId, points: pointPrice }) }, "Unlock for " + formattedDollarPrice + " / ",
                        React.createElement(Points, { className: s['points-icon'], size: IconSize.TINY, disableDefaultColors: true }), "" + pointPrice)))),
            isWatchToAccess && (React.createElement(React.Fragment, null,
                React.createElement(EyeDisc2, { className: s['paywall-icon'], size: IconSize.BIG }),
                React.createElement("div", { className: s['paywall-title'] }, t('deviation.paywall.watchersOnly.title')),
                React.createElement("div", { className: s['cta-text'] }, t('deviation.paywall.watchersOnly.text')),
                deviation.author && (React.createElement(ProfileOwnerWatchButton, { className: s['watch-button'], user: deviation.author, onToggleWatchSuccess: function () {
                        window.location.href = deviation.url;
                    } })))),
            isPrivilegedFolder && (React.createElement(React.Fragment, null,
                React.createElement(CoreIconSmall, { className: s['paywall-icon'] }),
                React.createElement("div", { className: s['paywall-title'] }, t('deviation.paywall.privilegedFolders.title')),
                React.createElement("div", { className: s['cta-text'] },
                    React.createElement(Trans, { i18nKey: "deviation.paywall.privilegedFolders.text" },
                        'To view, buy ',
                        React.createElement(BiLink, { className: s['buy-core-button'], href: URLS.CORE_MEMBERSHIP }, "CORE Membership"))))))));
};
PremiumCover.displayName = 'PremiumCover';
export default PremiumCover;
//# sourceMappingURL=PremiumCover.js.map